import { useI18n } from 'vue-i18n'
import type { MessageSchema } from '@/locales/schema'
import { useI18nTyped } from '@/composables/useI18nTyped'

export const formatDate = (
  isoString?: string | null,
  hideTime: boolean = false,
  hideDate: boolean = false,
) => {
  if (!isoString) return '—'
  const { locale } = useI18n<{ message: MessageSchema }>({})

  const date = new Date(isoString)
  return Intl.DateTimeFormat(locale.value, {
    year: hideDate ? undefined : 'numeric',
    day: hideDate ? undefined : '2-digit',
    month: hideDate ? undefined : 'short',
    hour: hideTime ? undefined : 'numeric',
    minute: hideTime ? undefined : 'numeric',
  }).format(date)
}

export const formatShortDate = (isoString?: string | null) => {
  if (!isoString) return '—'
  const { locale } = useI18n<{ message: MessageSchema }>({})

  const date = new Date(isoString)
  return Intl.DateTimeFormat(locale.value, {
    year: 'numeric',
    day: '2-digit',
    month: 'short',
  }).format(date)
}

export const formatMinutesToText = (minutes: number): string => {
  const { t } = useI18nTyped()

  if (!minutes) return '—'

  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60

  const hoursText = t('common.hours_short', [hours])
  const minutesText = t('common.minutes_short', [remainingMinutes])

  if (hours === 0) {
    return t('common.minutes_short', [remainingMinutes])
  }
  if (remainingMinutes === 0) {
    return t('common.hours_short', [hours])
  }

  return `${hoursText} ${minutesText}`
}
